import React from 'react'
import Container from '@material-ui/core/Container'
import styleClasses from '../components/common/common.module.scss'
import AmenityList from '../components/amenities/AmenityList'

export default function AmenitiesPage() {
  return (
    <main className={styleClasses.content}>
      <Container maxWidth="lg" className={styleClasses.container}>
        <AmenityList />
      </Container>
    </main>
  )
}
